import { useEffect } from 'react';
import { lineMdClose } from "@/config/config";
import host from "@/utils/host";
import styles from './index.module.scss';
import useLanguage from "@/hooks/useLanguage";

const PopupMobile = ({ isVisible, confirmText, closePopup }) => {
  const { t } = useLanguage();

  useEffect(() => {
    if (isVisible) {
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
    } else {
      // 恢复页面滚动
      document.body.style.overflow = '';
    }
    // 在组件卸载时恢复页面滚动
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);
  return (
    isVisible && <div className={styles.overlay} onClick={(e) => {
      e.preventDefault();
      closePopup();
    }}
      onTouchMove={(e) => {
        e.preventDefault(); // 阻止默认的触摸移动行为，防止页面滚动
      }}>
      <div className={`${styles.popup} ${isVisible ? styles['popup-enter'] : styles['popup-exit']
        }`}
        onClick={(e) => e.stopPropagation()} // 阻止事件冒泡，避免点击内容关闭 Popup
      >
        <div className={styles.header}>
          <img src='images/sub-auth.png' className={styles.topIcon} />
          <img src={lineMdClose} onClick={closePopup} className={styles.headerRight} />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>{t('subMotAuthMobile.title')}</div>
          <ul className={styles.firstTitle}>
            <li>{t('subMotAuthMobile.after_auth')}</li>
            <ul className={styles.firstTitle}>
              <li>{t('subMotAuthMobile.view')} <span className={styles.diffText}>{t('subMotAuthMobile.marketplace_performance')}</span></li>
              <li>{t('subMotAuthMobile.view')} <span className={styles.diffText}>{t('subMotAuthMobile.showcase_info')}</span></li>
              <li><span className={styles.diffText}>{t('subMotAuthMobile.increase_commission')}</span> {t('subMotAuthMobile.on_showcase_products')}</li>
              <li>{t('subMotAuthMobile.check_progress')} <span className={styles.diffText}>{t('subMotAuthMobile.sample_application')}</span> {t('subMotAuthMobile.under_development')}</li>
            </ul>
            <li>{t('subMotAuthMobile.please')} <span className={styles.diffText}>{t('subMotAuthMobile.select_all')}</span> {t('subMotAuthMobile.authorized_content')}</li>
            <li>{t('subMotAuthMobile.data_usage')}</li>
            <li>{t('subMotAuthMobile.cancel_auth')}</li>
          </ul>
        </div>
        <div className={styles.footer}>
          <a href={`${host}/api/v2/tiktok/login`}>
            {confirmText}</a>
        </div>
      </div>
    </div>
  );
};
export default PopupMobile;